import React from 'react';
//import PropTypes from 'prop-types';
import cn from "classnames"
import injectSheet from 'react-jss';
import theme from "../../styles/theme"

function Subtitle(props) {
    const { classes, className, children } = props;
    return <div className={cn( classes.subTitle, className )} data-cy="subtitle">{children}</div>;
}

//Subtitle.propTypes = {
//};

export default injectSheet(
    {
        subTitle: {
            ...theme.font.subtitle
        },
    }
)(Subtitle);



// WEBPACK FOOTER //
// ./src/components/Widgets/Subtitle.js